export default __webpack_public_path__ + "03b53dc5c7cd2aed89f28eb3558fdc78.png";